import React from 'react'
import PageLayout from '../../components/PageLayout'
import TransfersToolbar from './TransfersToolbar'
import TransfersList from './TransfersList'
import TransfersDetails from './TransfersDetails'
import TransfersPlaceholder from './TransfersPlaceholder'
import { useSelector, useDispatch } from 'react-redux'
import { StoreState } from '../../store'
import { getTransfers } from '../../store/transfers/transfersActions'
import { TransfersActionTypes } from '../../store/transfers/transfersTypes'

export default function Transfers() {
  const dispatch = useDispatch()
  const { isEditing, selectedIndex } = useSelector((state: StoreState) => ({
    isEditing: state.transfersState.isEditing,
    selectedIndex: state.transfersState.selectedIndex,
  }))

  const onMountPage = () => dispatch(getTransfers())
  const onUnmountPage = () => dispatch({ type: TransfersActionTypes.CLEAR })

  return (
    <PageLayout
      toolbar={<TransfersToolbar />}
      list={<TransfersList />}
      details={<TransfersDetails key={String(selectedIndex)} />}
      detailsPlaceholder={<TransfersPlaceholder />}
      hideDetails={!isEditing}
      onMountPage={onMountPage}
      onUnmountPage={onUnmountPage}
    />
  )
}
